var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactUsGmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2378_702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.82382 -0.0712891H14.1762C15.1781 -0.0695244 15.998 0.738534 15.998 1.73718V10.2625C15.998 11.2581 15.1792 12.0709 14.1762 12.0709H1.82382C0.820797 12.0709 0.00195312 11.2581 0.00195312 10.2625V1.73718C0.0021309 0.739417 0.81902 -0.0679361 1.82382 -0.0712891ZM15.0535 1.65883L8.9024 6.75318C8.36426 7.19895 7.58613 7.18871 7.07146 6.7313L0.946487 1.65883C0.944175 1.68459 0.942931 1.71071 0.942931 1.73718V10.2625C0.942931 10.7425 1.34044 11.1369 1.82382 11.1369H14.1762C14.6596 11.1369 15.0571 10.7425 15.0571 10.2625V1.73718C15.0571 1.71071 15.0558 1.68459 15.0535 1.65883ZM8.30329 6.03795L14.4848 0.918711L14.1764 0.86277L1.77902 0.864005L1.51555 0.918887L7.69884 6.03812C7.87484 6.18424 8.12782 6.18318 8.30329 6.03795Z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2378_702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsGmailIcon);
export default __webpack_public_path__ + "static/media/contactUsGmailIcon.48b0f82f1c852e4cefabcfb120a2f4cd.svg";
export { ForwardRef as ReactComponent };